import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import DatePicker from 'react-datepicker2';

export default class Stone extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            templateId: props.TemplateId,
            isTemplate: props.IsTemplate,
            data: null,
            loading: true,
            pic: '',
            picFileName: '',
            version: this.uuidv4()
        };
    }
    setProfilePic(_file) {
        this.getBase64(_file).then(file => {
            this.state.pic = file;
            this.state.picFileName = _file.name;
        });
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/stone/get", {
            id: this.getCurrentFormId(),
            templateId: this.state.templateId,
            isTemplate: this.state.isTemplate
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    resetPrint(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/luxury/print/reset", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/stone/save", {
            id: this.state.id,
            templateId: this.state.data.record.templateId,
            isTemplate: this.state.data.record.isTemplate,
            note: this.state.data.record.note,
            tol: this.state.data.record.tol,
            arz: this.state.data.record.arz,
            vazn: this.state.data.record.vazn,
            height: this.state.data.record.height,
            typeId: this.state.data.record.typeId,
            colorId: this.state.data.record.colorId,
            sizeId: this.state.data.record.sizeId,
            kindId: this.state.data.record.kindId,
            weightId: this.state.data.record.weightId,
            rank: this.state.data.record.rank,
            difficulty: this.state.data.record.difficulty,
            applicantId: this.state.data.record.applicantId,
            randomCode: this.state.data.record.randomCode,
            serial: this.state.data.record.serial,
            characteristics: this.state.data.record.characteristics,
            sg: this.state.data.record.sg,
            ri: this.state.data.record.ri,
            date: this.convertMomentToDb(this.state.data.record.date),
            pic: this.state.pic,
            picFileName: this.state.picFileName,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    serialMaker() {
        if (this.state.data.record.isTemplate) return;
        if (this.state.data.record.printCount > 0) return;
        var stoneName = "";
        for (var i = 0; i < this.state.data.constants.length; i++) {
            if (this.state.data.constants[i].id === this.state.data.record.typeId) stoneName = this.state.data.constants[i].titleEn;
        }

        var colorName = "";
        for (var i = 0; i < this.state.data.constants.length; i++) {
            if (this.state.data.constants[i].id === this.state.data.record.colorId) colorName = this.state.data.constants[i].titleEn;
        }

        var year = this.state.data.record.date.format('YYYY').substr(2, 2);

        if (!this.isBlank(stoneName)) stoneName = stoneName.substr(0, 2);
        if (!this.isBlank(colorName)) colorName = colorName.substr(0, 2);

        this.state.data.record.serial = "TFC-" + stoneName + "-" + colorName + "-" + year + "-" + this.state.data.record.randomCode;

        this.setState({ data: this.state.data });
    }
    setType(e) {
        this.state.data.record.typeId = e.target.value;
        this.serialMaker();
    }
    setColor(e) {
        this.state.data.record.colorId = e.target.value;
        this.serialMaker();
    }
    setDate(e) {
        this.state.data.record.date = e;
        this.serialMaker();
    }
    hasField(v) {
        return this.state.data.fields.includes('[' + v + ']');
    }
    fillForm(e) {
        if (e == this.defaultGuid()) return;
        this.httpPost("api/v1/stone/get", {
            id: e,
            templateId: this.state.data.record.templateId,
            isTemplate: false
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data.record.note = data.record.note;
                    this.state.data.record.tol = data.record.tol;
                    this.state.data.record.arz = data.record.arz;
                    this.state.data.record.vazn = data.record.vazn;
                    this.state.data.record.height = data.record.height;
                    this.state.data.record.typeId = data.record.typeId;
                    this.state.data.record.colorId = data.record.colorId;
                    this.state.data.record.sizeId = data.record.sizeId;
                    this.state.data.record.kindId = data.record.kindId;
                    this.state.data.record.weightId = data.record.weightId;
                    this.state.data.record.rank = data.record.rank;
                    this.state.data.record.difficulty = data.record.difficulty;
                    this.state.data.record.characteristics = data.record.characteristics;
                    this.state.data.record.sg = data.record.sg;
                    this.state.data.record.ri = data.record.ri;
                    this.state.version = this.uuidv4();
                    if (this.state.data.record.printCount > 0)
                        this.setState({ data: this.state.data });
                    else
                        this.serialMaker();
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات سنگ" : "افزودن سنگ جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row" key={this.state.version}>
                                    {!this.state.data.record.isTemplate && <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">تکمیل فرم بر اساس تمپلیت انتخابی</label>
                                            <select onChange={e => this.fillForm(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.data.templates.map(t => <option value={t.id}>{ t.serial}</option>)}
                                            </select>
                                        </div>
                                    </div>}
                                    {!this.state.data.record.isTemplate ?
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label for="name" className="title1">شماره ثبت</label>
                                                <input value={this.state.data.record.serial} readOnly={true} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                        </div>
                                        : <div className="col-sm-12">
                                            <div className="form-group">
                                                <label for="name" className="title1">عنوان</label>
                                                <input defaultValue={this.state.data.record.serial} onChange={e => this.state.data.record.serial = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                        </div>
                                    }
                                    {!this.state.data.record.isTemplate && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">مشتری</label>
                                            <select defaultValue={this.state.data.record.applicantId} onChange={e => this.state.data.record.applicantId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.defaultGuid()}>انتخاب کنید...</option>
                                                {this.state.data.applicants.map(r =>
                                                    <option value={r.id}>{r.name}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>}
                                    {!this.state.data.record.isTemplate && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">تاریخ صدور</label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.setDate(e) }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                            />
                                        </div>
                                    </div>}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">نوع سنگ</label>
                                            <select defaultValue={this.state.data.record.typeId} onChange={e => this.setType(e)} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.defaultGuid()}>انتخاب کنید...</option>
                                                {this.state.data.constants.map(r =>
                                                    r.type === 1 && <option value={r.id}>{r.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    {this.hasField("kindId") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">نوع تراش</label>
                                            <select defaultValue={this.state.data.record.kindId} onChange={e => this.state.data.record.kindId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.defaultGuid()}>انتخاب کنید...</option>
                                                {this.state.data.constants.map(r =>
                                                    r.type === 4 && <option value={r.id}>{r.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>}
                                    {this.hasField("weightId") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">نوع وزن</label>
                                            <select defaultValue={this.state.data.record.weightId} onChange={e => this.state.data.record.weightId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.defaultGuid()}>انتخاب کنید...</option>
                                                {this.state.data.constants.map(r =>
                                                    r.type === 2 && <option value={r.id}>{r.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">رنگ</label>
                                            <select defaultValue={this.state.data.record.colorId} onChange={e => this.setColor(e)} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.defaultGuid()}>انتخاب کنید...</option>
                                                {this.state.data.constants.map(r =>
                                                    r.type === 5 && <option value={r.id}>{r.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    {this.hasField("sizeId") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">واحد ابعاد</label>
                                            <select defaultValue={this.state.data.record.sizeId} onChange={e => this.state.data.record.sizeId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.defaultGuid()}>انتخاب کنید...</option>
                                                {this.state.data.constants.map(r =>
                                                    r.type === 3 && <option value={r.id}>{r.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>}
                                    {this.hasField("vazn") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">وزن</label>
                                            <input defaultValue={this.state.data.record.vazn} onChange={e => this.state.data.record.vazn = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("tol") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">طول</label>
                                            <input defaultValue={this.state.data.record.tol} onChange={e => this.state.data.record.tol = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("arz") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">عرض</label>
                                            <input defaultValue={this.state.data.record.arz} onChange={e => this.state.data.record.arz = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("height") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">ارتفاع</label>
                                            <input defaultValue={this.state.data.record.height} onChange={e => this.state.data.record.height = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("rank") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">رتبه بندی</label>
                                            <input defaultValue={this.state.data.record.rank} onChange={e => this.state.data.record.rank = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("difficulty") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">درجه سختی</label>
                                            <input defaultValue={this.state.data.record.difficulty} onChange={e => this.state.data.record.difficulty = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("ri") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">ضریب شکست</label>
                                            <input defaultValue={this.state.data.record.ri} onChange={e => this.state.data.record.ri = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("sg") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">وزن مخصوص</label>
                                            <input defaultValue={this.state.data.record.sg} onChange={e => this.state.data.record.sg = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("characteristics") && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">پاکی سنگ</label>
                                            <input defaultValue={this.state.data.record.characteristics} onChange={e => this.state.data.record.characteristics = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>}
                                    {this.hasField("note") && <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات</label>
                                            <textarea defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" style={{ "height": "80px", "min-height": "80px" }}></textarea>
                                        </div>
                                    </div>}
                                    {this.hasField("pic") && !this.state.data.record.isTemplate && <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">فایل تصویر</label>
                                            <div className="form-control-wrap">
                                                <input type="file" onChange={(e) => { this.setProfilePic(e.target.files[0]) }} />
                                            </div>
                                        </div>
                                    </div>}
                                    {this.hasField("pic") && !this.isBlank(this.state.data.record.pic) && <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="form-label">تصویر فعلی</label>
                                            <div className="form-control-wrap">
                                                <a href={"/media/" + this.state.data.record.pic} target="_blank">مشاهده فایل</a>
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="ms-2 me-2 btn btn-success">
                                ذخیره
                            </button>
                            {this.state.data.global.user.role === 1 && this.state.data.record.printed &&
                                <button type="submit" onClick={e => this.resetPrint(e)} className="ms-2 me-2 btn btn-danger">
                                    حذف قفل ویرایش
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}